import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { selectIsArabic } from '../../store/selectors/language.selectors';

@Component({
  standalone: true,
  imports: [FormsModule, MatDialogModule, TranslatePipe],
  styles: [`
    .terms-layout { display: flex; flex-direction: column; min-height: 0; max-height: inherit; }
  `],
  template: `
    <div class="terms-layout" [class.rtl-mode]="isArabic()" [class.ltr-mode]="!isArabic()">
    <h2 mat-dialog-title>{{ 'SAFETY_AGREEMENT_TITLE' | translate }}</h2>
    <mat-dialog-content>
      <p>{{ 'SAFETY_AGREEMENT_VERSION' | translate }} {{ data.version }}</p>
      <nav class="d-flex flex-wrap gap-2 mb-3">
        <button type="button" class="btn btn-outline-primary" (click)="privacy = false">{{ 'TERMS' | translate }}</button>
        <button type="button" class="btn btn-outline-primary" (click)="privacy = true">{{ 'DATA_PROTECTION' | translate }}</button>
      </nav>
      <div [innerHTML]="privacy ? data.privacy : data.terms"></div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <label class="d-flex w-100 gap-2 align-items-center p-2" [class.rtl-mode]="isArabic()" [class.ltr-mode]="!isArabic()">
        <input class="flex-shrink-0" type="checkbox" [(ngModel)]="accepted" />
        <span class="flex-grow-1">{{ 'SAFETY_AGREEMENT_ACCEPT' | translate }}</span>
      </label>
      <button type="button" class="btn btn-outline-secondary mx-2" (click)="dialog.close(false)">{{ 'CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary" [disabled]="!accepted" (click)="dialog.close(true)">{{ 'SAFETY_AGREEMENT_CONTINUE' | translate }}</button>
    </mat-dialog-actions>
    </div>
  `,
})
export class TermsAgreementDialog {
  readonly isArabic = inject(Store).selectSignal(selectIsArabic);
  readonly data = inject<{ version: string; terms: string; privacy: string }>(MAT_DIALOG_DATA);
  readonly dialog = inject(MatDialogRef<TermsAgreementDialog>);
  accepted = false;
  privacy = false;
}
